import { prodapiAxiosClient } from "./prodApiClient";

const authUser = (userData) => {
    return prodapiAxiosClient
    .post("/api/v1/user/login", userData)
}

const registerUser = (userData) => {
    return prodapiAxiosClient
    .post("/api/v1/user", userData)    
}

const authApi = {authUser, registerUser}
export default authApi;